/**
 * `/admin/technical` — Technique : audit trail + diagnostics infra.
 *
 * Regroupe le journal d'audit (toutes les actions du personnel Fonbex
 * sur les organisations clientes) et les diagnostics techniques (Resend, API).
 */
import React from "react";
import { AdminPageHeader } from "./ui";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ClipboardList, Mail } from "lucide-react";
import { AuditTab, DiagnosticsTab } from "@/pages/app/PlatformAdminPage";

export default function AdminTechnicalPage() {
  return (
    <div className="animate-fade-up text-foreground">
      <AdminPageHeader
        overline="Technique"
        title="Audit &amp; diagnostics"
        description="Toutes les actions du personnel Fonbex sur les organisations clientes sont journalisées ici. Les diagnostics vérifient les intégrations critiques (Resend, e-mails, API)."
        testId="admin-technical-header"
      />
      <div className="rounded-2xl bg-background text-foreground p-4 sm:p-6 border border-white/10">
        <Tabs defaultValue="audit">
          <TabsList className="mb-6">
            <TabsTrigger value="audit" data-testid="admin-technical-tab-audit">
              <ClipboardList className="h-3.5 w-3.5 mr-1.5" />Journal d&apos;audit
            </TabsTrigger>
            <TabsTrigger value="diagnostics" data-testid="admin-technical-tab-diagnostics">
              <Mail className="h-3.5 w-3.5 mr-1.5" />Diagnostics
            </TabsTrigger>
          </TabsList>
          <TabsContent value="audit"><AuditTab /></TabsContent>
          <TabsContent value="diagnostics"><DiagnosticsTab /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
